import React from "react";
import styled from "styled-components";

const H1 = "h1";
const H2 = "h2";
const H3 = "h3";
const H4 = "h4";
const H5 = "h5";

const Heading1 = styled.h1`
  font-size: 65px;
  font-weight: 700;
  line-height: 98px;
  letter-spacing: -0.023em;
  text-align: left;
  color: #004368;
`;
const Heading2 = styled.h2`
  font-size: 40px;
  font-weight: 600;
  line-height: 60px;
  letter-spacing: -0.023em;
  text-align: left;
`;
const Heading3 = styled.h3`
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: -0.023em;
  text-align: left;
`;
const Heading4 = styled.h4``;
const Heading5 = styled.h5``;
const Paragraph = styled.p``;

const Typography = ({ variant, ...props }) => {
  switch (variant) {
    case H1: {
      return <Heading1 {...props} />;
    }
    case H2: {
      return <Heading2 {...props} />;
    }
    case H3: {
      return <Heading3 {...props} />;
    }
    case H4: {
      return <Heading4 {...props} />;
    }
    case H5: {
      return <Heading5 {...props} />;
    }
    default: {
      return <Paragraph {...props} />;
    }
  }
};

export default Typography;
